import { CONFIG } from 'Config/config'

export const checkSftpDownloadPermission = async (email, countryCode) => {
  const params = new URLSearchParams({ email, countryCode })
  const response = await fetch(
    `${CONFIG.API_BASE_URL}/sftp/country-permissions/check?${params}`,
    {
      method: 'GET',
      credentials: 'include',
    },
  )
  if (!response.ok) {
    return false
  }
  const data = await response.json()
  return data.hasPermission === true
}

export const getSftpAdminFiles = async (
  clientId,
  { limit = 20, continuationToken } = {},
) => {
  const params = new URLSearchParams({ clientId, limit: String(limit) })
  if (continuationToken) {
    params.set('continuationToken', continuationToken)
  }
  const response = await fetch(
    `${CONFIG.API_BASE_URL}/sftp/admin/files?${params}`,
    {
      method: 'GET',
      credentials: 'include',
    },
  )
  return response.json()
}
